import React, {useState} from 'react'
import PropTypes from 'prop-types';
import Form from 'components/Form';
import GridBlock from 'components/GridBlock';
import {connect} from 'react-redux'
import Loading from 'components/Loading';
import ExPostFields from './ExPostFields';
import getObjectValue from 'libs/getObjectValue'
import DemandService from 'services/DemandService';
import SaveFormikValues from 'components/SaveFormikValues';
import validationSchemaExPost from './constants/validationSchemaExPost';
import ShowErrorOnFailedSubmit from 'components/ShowErrorOnFailedSubmit';
import {DemandValidation} from 'constants/DemandValidation';
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import HeaderService from "services/HeaderService";
import {useParams, withRouter} from "react-router";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import AutoSaveFormValues from "components/AutoSaveFormValues";
import saveFormDraft from "libs/saveFormDraft";

function MainFormExPost(
    {
        data,
        demandAvailableOrganizations,
        demandRealizationTypes,
        numberAutomated,
        stepperState,
        demandValidation,
        demandHeader
    }) {
    const [checkError, setCheckError] = useState(false)
    const section = demandValidation.find(x => x.section === DemandValidation.DEMAND);
    const FORM_ID = 'mp_1_demand';
    const params = useParams();
    const autoSaveFormDraftActive = demandHeader?.applicationClientSettings.autoSaveFormDraft.active;
    useStepperStateCloseValidator(FORM_ID, undefined,
        autoSaveFormDraftActive ? () => DemandService.deleteDraftExPost(params.id) : undefined,
        autoSaveFormDraftActive ? () => saveFormDraft(params.id, DemandService.saveDraftExPost, FORM_ID) : undefined);

    if (!data || !demandAvailableOrganizations || !demandRealizationTypes) {
        return <Loading/>
    }


    const handleSubmit = (values) => {
        DemandService.saveExPost(values).then(() => {
            if (data.identity !== -1) {
                HeaderService.get(data.identity)
            }
        });
    }

    const getField = (id, defaultValue = '') => getObjectValue(id, data, defaultValue);

    return (
        <Form
            initialValues={{
                _editable: section ? section.editable : true,
                identity: getField('identity'),
                organization: getField('organization'),
                procedureType: getField('procedureType'),
                authorUser: getField('authorUser'),
                number: getField('number'),
                demandCategoryType: getField('demandCategoryType', null),
                name: getField('name'),
                demandRealizationType: getField('demandRealizationType'),
                demandOrderType: getField('demandOrderType'),
                primaryTenderVariant: getField('primaryTenderVariant'),
                estimatedValue: getField('estimatedValue'),
                realizationGrossValue: getField('realizationGrossValue'),
                realizatedValue: getField('realizatedValue'),

                enableOptional: false,

                ezdrpId: getField('ezdrpId'),
                ezdpuwId: getField('ezdpuwId'),
            }}
            validationSchema={validationSchemaExPost(demandRealizationTypes, numberAutomated)}
            onSubmit={handleSubmit}
            id={FORM_ID}
            afterSubmitFunc={() => {
                setCheckError(true);
                if (isDemandModification()) {
                    ModificationService.isDemandChanged(data.identity);
                }
            }}
        >
            {(formikProps) => {
                return (
                    <GridBlock
                        column
                    >
                        <ShowErrorOnFailedSubmit
                            formikProps={formikProps}
                            checkError={checkError}
                            setCheckError={setCheckError}
                        />
                        <SaveFormikValues
                            formikProps={formikProps}
                            id={FORM_ID}
                            save={FORM_ID === stepperState}
                        />
                        {autoSaveFormDraftActive &&
                        <AutoSaveFormValues
                            formikProps={formikProps}
                            id={getField('identity')}
                            formId={FORM_ID}
                            saveFunc={(formValues) => {
                                DemandService.saveDraftExPost(getField('identity'), formValues)
                            }}
                        />
                        }
                        <ExPostFields
                            formikProps={formikProps}
                            demandAvailableOrganizations={demandAvailableOrganizations}
                            demandRealizationTypes={demandRealizationTypes}
                            numberAutomated={numberAutomated}
                            demandHeader={demandHeader}
                            hideExecutiveDemandVariant={getField('hideExecutiveDemandVariant', true)}
                        />

                    </GridBlock>
                )
            }}
        </Form>
    )
}

MainFormExPost.propTypes = {
    classes: PropTypes.any,
}

MainFormExPost.defaultProps = {}


export default connect((state) => ({
    data: state.resources.demand,
    demandAvailableOrganizations: state.resources.demandAvailableOrganizations,
    demandRealizationTypes: state.resources.demandRealizationTypes,
    numberAutomated: state.resources.demandNumberAutomated,
    demandHeader: state.resources.demandHeader,
    stepperState: state.stepper.state,
    demandValidation: state.resources.demandValidation,
}), {})(withRouter(MainFormExPost));
